module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="shade">\n	<div class="shade-box">\n		<div class="bottom-content">\n			';
 btn.forEach(function(item,index){ ;
__p += '\n				<div data="' +
((__t = ( index )) == null ? '' : __t) +
'" class="btn">\n					' +
((__t = (  item )) == null ? '' : __t) +
'\n				</div>\n			';
 }) ;
__p += '\n		</div>\n		<div class="bottom-cancel">\n			取消\n		</div>\n	</div>\n</div>\n\n';

}
return __p
};